<template>
<el-drawer
    title="工作流追踪"
    :enums="enums"
    :with-header="true"
    :visible.sync="control.showTrace"
    direction="rtl"
    :append-to-body="true"
    :modal-append-to-body="false"
    :modal="false"
    size="90%">
  <div class="app-table-container">
    <!-- 查询条件 -->
    <el-form :model="queryForm">
        <el-row>
          <el-form-item label="任务名称" :label-width="formLabelWidth">
            <el-input style="width: 20%;" v-model="queryForm.title" maxlength="100" size="small" placeholder="请输入名称" />
          <el-button type="primary" size="small" @click="handlePage()">搜索</el-button>
          <!-- <el-button size="small" @click="reset()">重置</el-button> -->
          </el-form-item>
      </el-row>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      stripe
      :header-cell-style="{ background:'#eef1f6', color:'#606266' }"
      :data="tableData"
      :height="tableHeight"
      ref="tableContainer"
      class="table-container">
      <!-- <el-table-column prop="id" label="id" type="selection" fixed></el-table-column> -->
      <!-- <el-table-column
        fixed
        prop="id"
        label="ID"
        levelKey="depth"
        treeKey="id"
        parentKey="parentId"
        childKey="children"
        min-width="80px">
        </el-table-column> -->

      <el-table-column
        prop="title"
        min-width="60px"
        label="节点信息">
        <template slot-scope="scope">
          <div>ID:{{scope.row.id}}</div>
          <div>名称:{{scope.row.title}}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        min-width="60px"
        label="基本信息">
        <template slot-scope="scope">
          <el-divider>模型</el-divider>
          <div>模型:{{scope.row.modelTypeLabel}}</div>
          <div>温度:{{scope.row.temperature}}</div>
          <el-divider>Token用量</el-divider>
          <div>输入：{{scope.row.usage1?JSON.parse(scope.row.usage1).promptTokens:0}}</div>
          <div>输出：{{scope.row.usage1?JSON.parse(scope.row.usage1).generationTokens:0}}</div>
          <div>总量：{{scope.row.usage1?JSON.parse(scope.row.usage1).totalTokens:0}}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="question"
        min-width="100px"
        label="输入">
        <template slot-scope="scope">
          <el-divider>用户提问</el-divider>
          <div class="table-cell" v-html="replaceLineBreaks(scope.row.question)"></div>
          <el-divider>系统角色</el-divider>
          <div class="table-cell" v-html="replaceLineBreaks(scope.row.systemRole)"></div>
        </template>
      </el-table-column>

      <el-table-column
        prop="answer"
        min-width="100px"
        label="输出">
        <template slot-scope="scope">
          <div class="table-cell" v-html="replaceLineBreaks(scope.row.answer)"></div>
        </template>
      </el-table-column>

<!--      <el-table-column
        prop="publishFlag"
        label="是否奖励金币"
        min-width="80px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.desktopFlag" :disabled="scope.row.desktopFlag" type="success" size="mini" round>已发放</el-button>
          <el-button v-else @click="$permits.has(targetPermit,$permits.CREATE)?handlePublish(scope.row,true):''" :disabled="scope.row.desktopFlag" type="danger" size="mini" round>发放金币</el-button>
          <el-button @click="handlePublish(scope.row,false)" type="warning" size="mini" round>重新提交</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <el-row>
      <el-col>
        <div class="pagination">
          <el-pagination background
            v-if="paginations.total>0"
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"/>
        </div>
      </el-col>
    </el-row>
    <trace-form v-if="control.show" :control="control" :stores="stores" :enums="enums" :parents="parents" />
  </div>
</el-drawer>
</template>
<script>
import * as EnumApi from '@/api/enums'
import * as WorkflowNodeApi from '@/api/workflownode'
import TraceForm from './form'
export default {
  name: 'Trace',
  components: {
    TraceForm
  },
  props: {
    control: Object
  },
  data() {
    return {
      formLabelWidth: '80px',
      stores: [],
      enums: [],
    	// 权限key
      targetPermit: 'task',
      tableHeight: 0,
      queryForm: {
        title: '',
        fromType: 'desktop',
        current: 1,
        size: 10
      },
      controlTrace: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      tableData: [],
      parents: [],
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 10, // 每页行数
        sizes: [10, 20, 30, 40], // 每页行数 调整
        layout: 'total, sizes, prev, pager, next, jumper' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableContainer.$el.offsetHeight;
    })
    this.handlePage()
  },
  methods: {
    // 重置
    reset() {
      Object.keys(this.queryForm).forEach(key => (this.queryForm[key] = ''))
      this.handlePage()
    },
    replaceLineBreaks(str) {
      // return str
      return str?str.replace(/\n/g, '<br>'):"";
    },
    handleAction(action,item) {
      let that = this;
      console.log("action >> " + action)
      that.control.show = true;
      that.control.disabled = false;
      that.control.action = action;

      switch(action){
        case that.$permits.VIEW:
          that.control.title = "详情";
          that.control.disabled = true;
          that.control.form = item;
          console.log("switch >>> " + that.$permits.VIEW)
          break;
        case that.$permits.UPDATE:
          that.control.title = "编辑";
          that.control.form = item;
          console.log("switch >>> " + that.$permits.UPDATE)
          break;
        case that.$permits.CREATE:
          that.control.title = "新建";
          console.log("switch >>> " + that.$permits.CREATE)
          break;
      }
    },
    handleRemove(item) {
      let that = this;
      that.$confirm('', '确定删除套餐任务吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {

      }).catch((e) => {console.log('error', e)});
    },
    handleEnable(item) {
      let that = this;
      let tip = !item.enableFlag?'启用':'停用'
      that.$confirm('', '确定'+tip+'吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        WorkflowNodeApi.enabled({id: item.id, enabled: !item.enableFlag}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handlePublish(item, flag) {
      let that = this;
      let tip = flag?'发放':'重新提交'
      that.$confirm('', '确定'+tip+'吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {

      }).catch((e) => {console.log('error', e)});
    },
    handleEnum() {
      let that = this;
      // 获取表格数据
      EnumApi.list().then(res => {
        let result = res.data.data;
        that.enums = result
      })
    },
    handlePage(current) {
      console.log('current', current)
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size
      // 获取表格数据
      WorkflowNodeApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        that.tableData = result.records
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">
.table-cell {
  // white-space: pre-line; /* 使得换行符生效 */
  word-break: break-word; /* 允许在单词内换行 */
  max-height: 200px;
  overflow-y: auto;
}
</style>
